import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import SessionService from 'cio/services/session';

export default class ResetPasswordRoute extends Route {
  @service session!: SessionService;

  templateName = 'auth-form-layout';

  beforeModel(transition: Transition) {
    this.session.prohibitAuthentication('authenticated');

    return super.beforeModel(transition);
  }
}
